// @see https://github.com/arnellebalane/vue-intersect
import Vue from "vue";
import VueIntersect from '@arnellebalane/vue-intersect';
Vue.use(VueIntersect);